import {
  SUPERSET_PAIN_MINUTES_COUNT,
  SUPERSET_PAIN_MINUTES_COUNT_SUCCESS,
  SUPERSET_PAIN_MINUTES_COUNT_ERROR,
  SUPERSET_PAIN_MINUTES_COUNT_EMPTY,
} from '../../../../actionType';

const initialState = {
  data: null,
  message: null,
  loading: false,
  success: false,
  error: false,
};

const SupersetPainMinutesCount = (state = initialState, action) => {
  switch (action.type) {
    case SUPERSET_PAIN_MINUTES_COUNT:
      state = {
        ...state,
        // data: null,
        loading: true,
        success: false,
        error: false,
        message: null,
      };
      break;

    case SUPERSET_PAIN_MINUTES_COUNT_SUCCESS:
      state = {
        ...state,
        data: action.payload,
        loading: false,
        success: true,
        error: false,
        message: null,
      };
      break;

    case SUPERSET_PAIN_MINUTES_COUNT_ERROR:
      state = {
        ...state,
        data: null,
        loading: false,
        success: false,
        error: true,
        message: action.payload,
      };
      break;

    case SUPERSET_PAIN_MINUTES_COUNT_EMPTY:
      state = {
        ...initialState,
      };
      break;

    default:
      state = { ...state };
      break;
  }
  return state;
};

export default SupersetPainMinutesCount;
